import React, { useCallback, useState } from 'react';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';
import InformativeCard from '../InformativeCard';
import alarmClock from '../../../../assets/images/alarm-clock.png';
import CustomDialog from '../../../../components/CustomDialog';
import CustomDataTable from '../../../../components/CustomDataTable';
import { useFeedback } from '../../../../hooks/feedback';
import { CondominiumReducerData } from '../../../../store/reducers/condominiumReducer';
import { AppState } from '../../../../store';
import { RegisterRankingDTO } from '../../../../models/dto/RegisterRankingDTO';
import {
  subtract,
  toDefaultServerDateFormat,
} from '../../../../utils/date.util';
import { findEmployeesDelayRanking } from '../../../../services/personnelDepartment.service';

const EmployeesDelayCard: React.FC = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [employeesDelay, setEmployeesDelay] = useState<RegisterRankingDTO[]>(
    [],
  );

  const { addFeedback } = useFeedback();
  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  const handleCardClick = useCallback(async () => {
    try {
      const reference = condominiumSelected?.referencia;
      if (reference) {
        setEmployeesDelay([]);
        setOpenDialog(true);
        setLoading(true);
        const today = moment().toDate();
        const todayFormatted = toDefaultServerDateFormat(today);
        const aMonthAgo = toDefaultServerDateFormat(
          subtract(today, 1, 'month'),
        );

        const { data } = await findEmployeesDelayRanking(
          reference,
          aMonthAgo,
          todayFormatted,
        );
        setEmployeesDelay(data?.flatMap(item => item));
      }
    } catch (error) {
      addFeedback({
        type: 'error',
        description: 'Ocorreu um erro ao buscar as informações.',
      });
    } finally {
      setLoading(false);
    }
  }, [addFeedback, condominiumSelected]);

  const columns = [
    {
      name: 'numCad',
      label: 'Matrícula',
    },
    {
      name: 'nomeFuncionario',
      label: 'Nome do Colaborador',
    },
    {
      name: 'cargo',
      label: 'Função',
    },
    {
      name: 'dataApuracao',
      label: 'Data',
    },
    {
      name: 'totalHorasAtrasos',
      label: 'Total',
    },
  ];

  return (
    <>
      <InformativeCard
        imgAltText="Atrasos por Período"
        imgSrc={alarmClock}
        cardTitle="Funcionários com mais atrasos por período"
        cardText="Saiba quantos funcionários estão com mais ocorrências de atrasos."
        handleCardClick={handleCardClick}
      />
      <CustomDialog
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        handleConfirm={() => setOpenDialog(false)}
        showOneButton
        maxWidth="md"
        okButtonLabel="Fechar"
        showCloseButton
      >
        <CustomDataTable
          title={
            <Grid container direction="row">
              <Typography variant="h6">
                Funcionários com mais atrasos por período
              </Typography>
              {loading && (
                <CircularProgress
                  size={20}
                  style={{ marginLeft: 15, position: 'relative', top: 4 }}
                />
              )}
            </Grid>
          }
          data={employeesDelay}
          columns={columns}
          options={{ elevation: 0, download: true }}
        />
      </CustomDialog>
    </>
  );
};

export default EmployeesDelayCard;
